import React__default from 'react';
import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import '../common.scss.js';
import { warnOnce } from '../../utils/common.js';

var ApplicationTheme;
(function(ApplicationTheme2) {
  ApplicationTheme2["Light"] = "vai-theme-light";
  ApplicationTheme2["Dark"] = "vai-theme-dark";
})(ApplicationTheme || (ApplicationTheme = {}));
const ThemeContext = React__default.createContext(null);
const useTheme = () => {
  const currentContext = React__default.useContext(ThemeContext);
  if (!currentContext) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return currentContext;
};
const resetBodyClasses = () => {
  for (const theme of Object.values(ApplicationTheme)) {
    document.body.classList.remove(theme);
  }
};
const setBodyClass = (theme) => {
  resetBodyClasses();
  document.body.classList.add(theme);
};
const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = React__default.useState("light");
  React__default.useEffect(() => {
    setBodyClass(ApplicationTheme.Light);
  }, []);
  const changeTheme = React__default.useCallback((theme2) => {
    if (!theme2 || ["light", "dark"].indexOf(theme2) === -1) {
      warnOnce('ThemeProvider: changeTheme was called with an invalid theme. Valid themes are "light" and "dark".');
      return;
    }
    const themeClass = theme2 === "light" ? ApplicationTheme.Light : ApplicationTheme.Dark;
    setTheme(theme2);
    setBodyClass(themeClass);
  }, [setTheme]);
  const contextValue = React__default.useMemo(() => {
    const themeClass = theme === "light" ? ApplicationTheme.Light : ApplicationTheme.Dark;
    return { theme, changeTheme, themeClass };
  }, [changeTheme, theme]);
  return /* @__PURE__ */ React__default.createElement(ThemeContext.Provider, {
    value: contextValue
  }, children);
};

export { ApplicationTheme, ThemeContext, ThemeProvider, useTheme };
